export default __webpack_public_path__ + "static/boostBg-b01a026b119bbb2698ab34bf8b852b54.png";